import backendFetch from '../utils/backendFetch';
import type { AwsCredentialIdentity, Provider } from '@aws-sdk/types';

export class CognitoCredentialProvider {
  provider: Provider<unknown> | null = null;

  credentials: Promise<AwsCredentialIdentity> | null = null;

  constructor(private token: string, private accessToken: string) {}

  private initCredentialProvider() {
    this.credentials = backendFetch(
      'creds',
      { method: 'POST', body: { accessToken: this.accessToken } },
      this.token
    ).then(({ data }) => ({
      ...data.ChimeCredentials,
      expiration: new Date(data.ChimeCredentials.expiration)
    }));
    return this.credentials;
  }

  async getCredentialsProvider() {
    let credentials;
    if (this.credentials) {
      credentials = await this.credentials;
      if (credentials?.expiration! < new Date()) {
        credentials = await this.initCredentialProvider();
      }
    } else {
      credentials = await this.initCredentialProvider();
    }
    return credentials;
  }
  getToken() {
    return this.token;
  }
  getAccessToken() {
    return this.accessToken;
  }
}
